import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useContext } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import AppNavbar from "./AppNavbar";
import Sidebar from "./Sidebar";
import { t } from "i18next";

function Panel() {
  const { tokenLoaded, user } = useContext(AuthContext);

  if (!tokenLoaded || !user) {
    return <div>Loading...</div>;
  }

  const items: any[] = [
    {
      label: t("leagues"),
      to: "/panel/leagues",
      icon: icon({ name: "ranking-star", style: "solid" }),
    },
    {
      label: t("clubs"),
      to: "/panel/clubs",
      icon: icon({ name: "shield", style: "solid" }),
    },
    {
      label: t("players"),
      to: "/panel/players",
      icon: icon({ name: "users", style: "solid" }),
    }
  ];

  return (
    <div>
      <AppNavbar items={items} />
      <div className="container-fluid">
        <div className="row">
          <Sidebar items={items} />
          <div className="page-content p-4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Panel;
